import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getClientFees } from '../../../reducers/clients';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import FeeForm from '../../../components/forms/fee';
import Table from '../../../components/table';
import options from '../../../text/selectOptions';
import Modal from '../../../components/modal';
import Box from '../../../components/box';

class ClientConfigTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: {
                open: false,
                fee: undefined,
                action: undefined,
                title: undefined
            }
        };

        this.getColumnDefinition = this.getColumnDefinition.bind(this);

        // modal controls
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentDidMount() {
        const { fees, client, getClientFees } = this.props;
        if (!fees) {
            getClientFees(client.id);
        }
    }

    onOpen(fee = undefined, action = 'create') {
        let title;
        switch (action) {
            case 'update':
                title = { id: 'feeRule.update', defaultMessage: 'Update Fee Rule' };
                break;

            case 'delete':
                title = { id: 'feeRule.delete', defaultMessage: 'Delete Fee Rule' };
                break;

            case 'create':
            default:
                title = { id: 'feeRule.create', defaultMessage: 'New Fee Rule' };
                break;
        }

        this.setState({ ...this.state, modal: { open: true, fee, action, title: <FormattedMessage {...title} /> } });
    }

    onClose() {
        this.setState({ ...this.state, modal: { open: false, fee: undefined, action: undefined, title: undefined } });
    }

    getColumnDefinition() {
        return [
            { label: <FormattedMessage {...messages.weight} />, valueMap: d => d.priority, size: 'col-xs-2' },
            {
                label: <FormattedMessage {...messages.icw2} />,
                valueMap: d => (options.workerClassification.find(o => o.value === d.classify_result) || {}).label,
                size: 'col-xs-2 ellipsis'
            },
            {
                label: <FormattedMessage {...messages.states} />,
                valueMap: d => (d.location_group_id ? d.location_group_id : ''),
                size: 'col-xs-2 ellipsis'
            },
            { label: <FormattedMessage {...messages.rateThreshold} />, valueMap: d => d.rate_equal_or_above, size: 'col-xs-2 ellipsis' },
            { label: <FormattedMessage {...messages.fee} />, valueMap: d => `${d.fee}%`, size: 'col-xs-2 ellipsis' },
            {
                valueMap: d => (
                    <React.Fragment>
                        <i className="material-icons" onClick={() => this.onOpen(d, 'update')}>
                            edit
                        </i>
                        <i className="material-icons" onClick={() => this.onOpen(d, 'delete')}>
                            close
                        </i>
                    </React.Fragment>
                ),
                size: 'col-xs-2 text-right no-select'
            }
        ];
    }

    renderFeesSection() {
        const {
            modal: { open, fee, action, title }
        } = this.state;
        const { fees, client } = this.props;
        if (!fees) return null;

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedMessage id={'feesSectionHead'} defaultMessage={'Fees'} tagName={'h5'} />
                    </div>
                    <div className="col-xs-12 section">
                        <span className="button pull-right" onClick={() => this.onOpen()}>
                            <FormattedMessage {...messages.createFeeRule} />
                        </span>
                    </div>
                </div>
                <div className="col-xs-12">
                    <Table data={fees} columns={this.getColumnDefinition()} />
                </div>
                <Modal open={open} onClose={this.onClose} title={title} size="col-xs-12 col-sm-8 col-sm-offset-2">
                    <FeeForm fee={fee} client={client} cancel={this.onClose} action={action} />
                </Modal>
            </React.Fragment>
        );
    }

    renderInternationalSection() {
        const { client } = this.props;
        if (!client) return null;
        const { countries, currencies } = client;

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedMessage id={'intlSectionHead'} defaultMessage={'International'} tagName={'h5'} />
                        <p>Permitted countries: {JSON.stringify(countries)}</p>
                        <p>Permitted currencies: {JSON.stringify(currencies)}</p>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    render() {
        return (
            <div>
                <Box content={this.renderFeesSection()} />
                <Box content={this.renderInternationalSection()} />
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    const { client } = props;
    const fees = state.clients.fees;
    return {
        fees: fees ? fees[client.id] : undefined
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getClientFees
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ClientConfigTab);



// WEBPACK FOOTER //
// ./src/pages/client/tabs/config.jsx